<template>
  <OmtStickedModal
    @close="close"
    :footerBind="{
      position: ['initial', 'sticky'],
      bottom: '0',
      zIndex: '1',
      backgroundColor: 'white'
    }"
  >
    <template #header>
      <OmtButton :display="['block', 'none']" class="clear" variant="ghost" @click="clear" height="18px" p="0">
        <OmtTypography as="h3-bold" h="18px" w="46px" position="relative" color="var(--colors-light-primary-navy-blue)">
          Limpar
        </OmtTypography>
      </OmtButton>
    </template>

    <CBox :minHeight="['initial', 'calc(100vh - 400px)']">
      <CFlex justifyContent="space-between" :mb="['32px', '36px']">
        <OmtTypography as="h1-bold"> Ordenar </OmtTypography>
        <OmtButton class="clear" variant="ghost" @click="clear" height="18px" p="0" :display="['none', 'block']">
          <OmtTypography as="p1" h="18px" w="46px" position="relative"> Limpar </OmtTypography>
        </OmtButton>
      </CFlex>

      <template v-if="ordenacoesDisponiveis && ordenacoesDisponiveis.length > 0">
        <CBox v-for="(opcao, index) in ordenacoesDisponiveis" :key="opcao.Codigo">
          <CFlex justify="space-between" cursor="pointer">
            <OmtRadio
              @click="internalSort = opcao.Codigo"
              :value="opcao.Codigo"
              :isChecked="internalSort === opcao.Codigo"
              name="sort"
              :navyBlue="true"
            >
              <OmtTypography as="p1"> {{ opcao.Titulo }} </OmtTypography>
            </OmtRadio>
          </CFlex>
          <OmtDivider v-if="index < ordenacoesDisponiveis.length - 1" />
        </CBox>
      </template>
      <template v-else>
        <CFlex justify="space-between" cursor="pointer">
          <OmtRadio
            @click="internalSort = 'Indicação Omint'"
            value="Indicação Omint"
            :isChecked="internalSort === 'Indicação Omint'"
            name="sort"
            :navyBlue="true"
          >
            <OmtTypography as="p1"> Indicação Omint </OmtTypography>
          </OmtRadio>
        </CFlex>
        <OmtDivider />
        <CFlex justify="space-between" cursor="pointer">
          <OmtRadio
            @click="internalSort = 'Distância'"
            value="Distância"
            :isChecked="internalSort === 'Distância'"
            name="sort"
            :navyBlue="true"
          >
            <OmtTypography as="p1"> Distância </OmtTypography>
          </OmtRadio>
        </CFlex>
        <OmtDivider />
        <CFlex justify="space-between" cursor="pointer">
          <OmtRadio
            @click="internalSort = 'Rede e Distância'"
            value="Rede e Distância"
            :isChecked="internalSort === 'Rede e Distância'"
            name="sort"
            :navyBlue="true"
          >
            <OmtTypography as="p1"> Rede e Distância </OmtTypography>
          </OmtRadio>
        </CFlex>
      </template>
    </CBox>

    <template #footer>
      <OmtButton mb="32px" w="100%" @click="save"> Aplicar </OmtButton>
    </template>
  </OmtStickedModal>
</template>

<script>
export default {
  props: {
    sort: {
      type: String,
      default: ""
    },
    ordenacoesDisponiveis: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      internalSort: ""
    };
  },
  mounted() {
    this.internalSort = this.sort;
  },
  methods: {
    close() {
      this.$emit("close");
      this.clear();
    },
    clear() {
      this.internalSort = "";
    },
    save() {
      this.$emit("save", this.internalSort);
      this.close();
    }
  }
};
</script>
